import { render, staticRenderFns } from "./TopGavManagement.vue?vue&type=template&id=95190214&scoped=true"
import script from "./TopGavManagement.vue?vue&type=script&lang=js"
export * from "./TopGavManagement.vue?vue&type=script&lang=js"
import style0 from "./TopGavManagement.vue?vue&type=style&index=0&id=95190214&prod&lang=css"
import style1 from "./TopGavManagement.vue?vue&type=style&index=1&id=95190214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95190214",
  null
  
)

export default component.exports